type SectionHeadingProps = {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {kicker && (
        <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-widest uppercase text-primary-600">
          <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
          {kicker}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          {desc}
        </p>
      )}
    </div>
  );
}